export const linkColor = "#FF7A00";
export const highlight = "#8100FF";
export const workersColor = "#F95F76";
